<template>
  <div class="row px-4">
    <div class="col-12">
      <p class="text-center" data-aos="fade-in" data-aos-duration="1500" data-aos-delay="200">
        <i class="fal fa-info-circle fa-2x mb-2"></i>{{ $t('signatures_via_email', { email: applicationData.email }) }}
      </p>
    </div>
    <div class="form-group col-md-6" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <text-field v-model="applicationData.business_name" :readonly="!active || readonly" name="business_name" :label="$t('business_name_hint')" rules="required" />
    </div>
    <div class="form-group col-md-6" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <question
        v-model="applicationData.business_type"
        :label="$t('questions.business_type')"
        :options="localizedBusinessTypeOptions"
        :readonly="readonly"
        rules="required"
      />
    </div>
    <div class="form-group col-md-6" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <text-field v-model="applicationData.website" :readonly="!active || readonly" name="website" :label="$t('website_hint')" />
    </div>

    <div class="form-group col-md-6" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <text-field v-model="applicationData.business_description" :readonly="!active || readonly" name="business_description" :label="$t('business_description')" />
    </div>

    <div class="form-group col-md-6 offset-md-3" data-aos="fade-right" data-aos-duration="1500" data-aos-delay="200">
      <b-form-group v-show="active && !readonly" :label="$t('upload_business_card')">
        <image-uploader
          v-if="formData"
          :attr="attrForField"
          :max-files="1"
          :url="url"
          :process-result="processUpload"
          :form-data="formData"
        ></image-uploader>
      </b-form-group>
      <div class="row row-cols-1 row-cols-md-2">
        <generic-image v-for="image in images" :key="image.id" :image="image" />
      </div>
    </div>
    <more-info />
  </div>
</template>
<script>
import '@/shared/validations.js'
import Vue from 'vue'
import api from '@/cleaners/api'
import MoreInfo from './more_info.vue'
import TextField from '@/shared/inputs/text.vue'
import ImageUploader from '@/shared/uploaders/image.vue'
import GenericImage from '@/shared/generic_image.vue'
import Question from '@/shared/fields/cleaner_app_form_question.vue'

export default {
  components: {
    MoreInfo, TextField, ImageUploader, GenericImage, Question
  },
  props: {
    active: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      required: true
    },
    applicationId: {
      type: Number
    },
    applicationData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      imageContext: 'business_card',
      loading: true,
      images: [],
      options: $options
    }
  },
  computed: {
    attrForField() {
      return {
        name: 'cleaner_application_image[image]',
        key: 'id'
      }
    },
    localizedBusinessTypeOptions() {
      let options = []
      this.options.BUSINESS_TYPE.forEach((key) => {
        options.push(this.$t('options.business_type.' + key))
      })
      return options
    },
    url() {
      return "/api/cleaner_application_images"
    },
    formData() {
      if (this.applicationId) {
        return {
          'cleaner_application_id': this.applicationId, 'context': this.imageContext
        }
      }
    },
  },
  methods: {
    loadImages() {
      this.loading = true
      api.getApplicationImages(this.applicationId, this.imageContext).then(response => {
        this.images = response.data
        this.loading = false
      }, error => {
        this.loading = false
        this.$flasher.error(error.response.data.errors)
      })
    },
    processUpload(result, key) {
      this.loadImages()
      return result
    }
  },
  watch: {
    applicationId(newValue) {
      if (newValue) {
        this.loadImages()
      }
    }
  }
}
</script>
